import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './HomePage.module.css'
import {
  ConfigProvider,
  Menu,
  message,
  Tooltip,
} from 'antd'
import JSGC from './JSGC/JSGC'
// import JYZNT from './JYZNT_V1/JYZNT'
import JYZNT from './JYZNT/JYZNT'
import AIApplications from './AIApplications/AIApplications.js'

import menu_userManage from './menu_userManage.svg'
import menu_userManage_selected from './menu_userManage_selected.svg'

import menu_AIgongchuang from './menu_AIgongchuang.svg'
import menu_AIgongchuang_selected from './menu_AIgongchuang_selected.svg'

import menu_AIyingyong from './menu_AIyingyong.svg'
import menu_AIyingyong_selected from './menu_AIyingyong_selected.svg'

import menu_jiaoshigongchuang from './menu_jiaoshigongchuang.svg'
import menu_jiaoshigongchuang_selected from './menu_jiaoshigongchuang_selected.svg'

import menu_jiaoyuzhinengti from './menu_jiaoyuzhinengti.svg'
import menu_jiaoyuzhinengti_selected from './menu_jiaoyuzhinengti_selected.svg'

import menu_mingshigongzuoshi from './menu_mingshi.svg'
import menu_mingshigongzuoshi_selected from './menu_mingshi_selected.svg'

import menu_resource from './menu_resource.svg'
import menu_resource_selected from './menu_resource_selected.svg'

import menu_shoucang from './menu_shoucang.svg'
import menu_shoucang_selected from './menu_shoucang_selected.svg'

import menu_pingce from './menu_pingce.svg'
import menu_pingce_selected from './menu_pingce_selected.svg'

import menu_suyang from './menu_suyang.svg'
import menu_suyang_selected from './menu_suyang_selected.svg'

import menu_subject from './menu_subject.svg'
import menu_subject_selected from './menu_subject_selected.svg'

import menu_courseDesignAndRecord from './menu_courseDesignAndRecord.svg'
import menu_courseDesignAndRecord_selected from './menu_courseDesignAndRecord_selected.svg'

import menu_classroomInteractionAndTeaching from './menu_classroomInteractionAndTeaching.svg'
import menu_classroomInteractionAndTeaching_selected from './menu_classroomInteractionAndTeaching_selected.svg'

import menu_homeworkAssignmentAndMarking from './menu_homeworkAssignmentAndMarking.svg'
import menu_homeworkAssignmentAndMarking_selected from './menu_homeworkAssignmentAndMarking_selected.svg'

import menu_resourceGenerationAndManage from './menu_resourceGenerationAndManage.svg'
import menu_resourceGenerationAndManage_selected from './menu_resourceGenerationAndManage_selected.svg'

import menu_teachingAssistanceAndManage from './menu_teachingAssistanceAndManage.svg'
import menu_teachingAssistanceAndManage_selected from './menu_teachingAssistanceAndManage_selected.svg'

import menu_disciplineIntegrationCenter from './menu_disciplineIntegrationCenter.svg'
import menu_disciplineIntegrationCenter_selected from './menu_disciplineIntegrationCenter_selected.svg'

import menu_featuredSceneTools from './menu_featuredSceneTools.svg'
import menu_featuredSceneTools_selected from './menu_featuredSceneTools_selected.svg'
import menu_SYMOZX from './menu_SYMOZX.svg'
import menu_SYMOZX_selected from './menu_SYMOZX_selected.svg' 
import menu_boyaAijk from './menu_boyaAijk.svg'
import menu_boyaAijk_selected from './menu_boyaAijk_selected.svg'
import zhuanshiIcon from './zhuanshi.svg'

import TeacherManager from './teacherManager/teacherManager'
import WDBH from './WDBH/WDBH.js'
import { selectCurrentMenuKey, setCurrentMenuKey } from './HomePageSlice.js'
import {
  changeTipStatusRequest,
  getUserPointsRequest,
  getAppToken,
} from './HomePageApi.js'
import AISYZX from './AISYZX/AISYZX.js'
import AIPCZX from './AIPCZX/AIPCZX.js'
import MSGZS from './MSGZSList/MSGZSList.js'
import UserRechargePoints from './UserRechargePoints/UserRechargePoints'
import MyPointsInfo from './MyPointsInfo/MyPointsInfo'
import Cookies from 'js-cookie'
import UserInfoManager from './UserInfoManager/UserInfoManager.js'
import GlobalSearchResult from './GlobalSearchResult/GlobalSearchResult.js'
import ShoolAdminTip from './ShoolAdminTip/ShoolAdminTip.js'
import { clearAllCookies } from '../../util/handleObject.js'
import TeacherInfoManager from './TeacherInfoManager/TeacherInfoManager.js'
import ResourceLib from './ResourceLib/ResourceLib.js'
export default function HomePage() {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const current = useSelector(selectCurrentMenuKey)
  const [arrow, setArrow] = useState('Show')
  const [userName, setUserName] = useState(Cookies.get('name'))
  const [userHeaderImg, setUserHeaderImg] = useState(
    Cookies.get('image_url'),
  )
  const [showPointsInfo, setShowPointsInfo] = useState(false)
  const AIApplicationsRef = useRef(null)
  const [showUserInfoManager, setShowUserInfoManager] = useState(false)
  const [globalSearchStr, setGlobalSearchStr] = useState('')
  const [globalSearchType, setGlobalSearchType] = useState(1)

  function changeAIApplicationPage(page) {
    if (AIApplicationsRef.current) {
      AIApplicationsRef.current.changePage(page)
    } else {
      setTimeout(() => {
        changeAIApplicationPage(page)
      }, 300)
    }
  }

  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false
    }
    if (arrow === 'Show') {
      return true
    }
    return {
      pointAtCenter: true,
    }
  }, [arrow])
  const items = [
    {
      key: '1',
      // icon: <PieChartOutlined />,
      icon: (
        <img
          src={current == 1 ? menu_shoucang_selected : menu_shoucang}
          width={25}
          height={25}
        />
      ),
      label: '我的宝盒',
    },
    {
      key: '2',
      icon: (
        <img
          src={
            current.toString().charAt(0) == 2
              ? menu_AIyingyong_selected
              : menu_AIyingyong
          }
          width={25}
          height={25}
        />
      ),
      label: 'AI+学科',
      children: [
        {
          key: '28',
          icon: (
            <img
              src={current == 28 ? menu_subject_selected : menu_subject}
              width={25}
              height={25}
            />
          ),
          label: 'AI+X学科赋能',
        },
        {
          key: '21',
          icon: (
            <img
              src={
                current == 21
                  ? menu_courseDesignAndRecord_selected
                  : menu_courseDesignAndRecord
              }
              width={25}
              height={25}
            />
          ),
          label: '课程设计与备课',
        },
        {
          key: '22',
          icon: (
            <img
              src={
                current == 22
                  ? menu_classroomInteractionAndTeaching_selected
                  : menu_classroomInteractionAndTeaching
              }
              width={25}
              height={25}
            />
          ),
          label: '课堂互动与教学',
        },
        {
          key: '23',
          icon: (
            <img
              src={
                current == 23
                  ? menu_homeworkAssignmentAndMarking_selected
                  : menu_homeworkAssignmentAndMarking
              }
              width={25}
              height={25}
            />
          ),
          label: '作业布置与批改',
        },
        {
          key: '24',
          icon: (
            <img
              src={
                current == 24
                  ? menu_resourceGenerationAndManage_selected
                  : menu_resourceGenerationAndManage
              }
              width={25}
              height={25}
            />
          ),
          label: '资源生成与管理',
        },
        {
          key: '26',
          icon: (
            <img
              src={
                current == 26
                  ? menu_disciplineIntegrationCenter_selected
                  : menu_disciplineIntegrationCenter
              }
              width={25}
              height={25}
            />
          ),
          label: '学科融合中心',
        },
      ],
    },

    // {
    //   key: '3',
    //   icon: (
    //     <img
    //       src={
    //         current.toString().charAt(0) == '3'
    //           ? menu_AIgongchuang_selected
    //           : menu_AIgongchuang
    //       }
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: 'AI共创中心',
    //   children: [
    //     {
    //       key: '31',
    //       icon: (
    //         <img
    //           src={
    //             current == 31
    //               ? menu_mingshigongzuoshi_selected
    //               : menu_mingshigongzuoshi
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '名师工作室',
    //     },
    //     {
    //       key: '32',
    //       icon: (
    //         <img
    //           src={
    //             current == 32
    //               ? menu_jiaoyuzhinengti_selected
    //               : menu_jiaoyuzhinengti
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '教育智能体',
    //     },
    //     // {
    //     //   key: '33',
    //     //   icon: (
    //     //     <img
    //     //       src={
    //     //         current == 33
    //     //           ? menu_jiaoshigongchuang_selected
    //     //           : menu_jiaoshigongchuang
    //     //       }
    //     //       width={25}
    //     //       height={25}
    //     //     />
    //     //   ),
    //     //   label: '教师共创',
    //     // },
    //     {
    //       key: '34',
    //       icon: (
    //         <img
    //           src={
    //             current == 34
    //               ? menu_resource_selected
    //               : menu_resource
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '资源智库',
    //     },
    //   ],
    // },
    {
      key: '25',
      icon: (
        <img
          src={
            current == 25
              ? menu_teachingAssistanceAndManage_selected
              : menu_teachingAssistanceAndManage
          }
          width={25}
          height={25}
        />
      ),
      label: 'AI+办公',
    },
    {
      key: '27',
      icon: (
        <img
          src={
            current == 27
              ? menu_featuredSceneTools_selected
              : menu_featuredSceneTools
          }
          width={25}
          height={25}
        />
      ),
      label: '特色工具',
    },
    {
      key: '29',
      icon: (
        <img
          src={
            current == 29
              ? menu_SYMOZX_selected
              : menu_SYMOZX
          }
          width={25}
          height={25}
        />
      ),
      label: '实验模拟',
    },
    {
      key: 'boyaAijk',
      icon: (
        <img
          src={
            current == 'boyaAijk'
              ? menu_boyaAijk_selected
              : menu_boyaAijk
          }
          width={25}
          height={25}
        />
      ),
      label: '博雅AI建课',
    },
    {
      key: '32',
      icon: (
        <img
          src={
            current == 32
              ? menu_jiaoyuzhinengti_selected
              : menu_jiaoyuzhinengti
          }
          width={25}
          height={25}
        />
      ),
      label: '构建智能体',
    },
    {
      key: '4',
      icon: (
        <img
          src={current == 4 ? menu_pingce_selected : menu_pingce}
          width={25}
          height={25}
        />
      ),
      label: 'AI评测中心',
    },
    // {
    //   key: '5',
    //   icon: (
    //     <img
    //       src={current == 5 ? menu_suyang_selected : menu_suyang}
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: 'AI素养学院',
    // },
  ]
  const schoolAdminMenus = [
    {
      key: '6',
      // icon: <PieChartOutlined />,
      icon: (
        <img
          src={
            String(
              Math.abs(current) > 10 ? Math.floor(current / 10) : current,
            ) == 6
              ? menu_userManage_selected
              : menu_userManage
          }
          width={25}
          height={25}
        />
      ),
      label: '用户管理',
    },
    // {
    //   key: '1',
    //   // icon: <PieChartOutlined />,
    //   icon: (
    //     <img
    //       src={current == 1 ? menu_shoucang_selected : menu_shoucang}
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: '我的宝盒',
    // },
    // {
    //   key: '2',
    //   icon: (
    //     <img
    //       src={
    //         current.toString().charAt(0) == 2
    //           ? menu_AIyingyong_selected
    //           : menu_AIyingyong
    //       }
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: 'AI应用中心',
    //   children: [
    //     {
    //       key: '28',
    //       icon: (
    //         <img
    //           src={current == 28 ? menu_subject_selected : menu_subject}
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: 'AI+X学科赋能',
    //     },
    //     {
    //       key: '21',
    //       icon: (
    //         <img
    //           src={
    //             current == 21
    //               ? menu_courseDesignAndRecord_selected
    //               : menu_courseDesignAndRecord
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '课程设计与备课',
    //     },
    //     {
    //       key: '22',
    //       icon: (
    //         <img
    //           src={
    //             current == 22
    //               ? menu_classroomInteractionAndTeaching_selected
    //               : menu_classroomInteractionAndTeaching
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '课堂互动与教学',
    //     },
    //     {
    //       key: '23',
    //       icon: (
    //         <img
    //           src={
    //             current == 23
    //               ? menu_homeworkAssignmentAndMarking_selected
    //               : menu_homeworkAssignmentAndMarking
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '作业布置与批改',
    //     },
    //     {
    //       key: '24',
    //       icon: (
    //         <img
    //           src={
    //             current == 24
    //               ? menu_resourceGenerationAndManage_selected
    //               : menu_resourceGenerationAndManage
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '资源生成与管理',
    //     },
    //     {
    //       key: '25',
    //       icon: (
    //         <img
    //           src={
    //             current == 25
    //               ? menu_teachingAssistanceAndManage_selected
    //               : menu_teachingAssistanceAndManage
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '教学协助与管理',
    //     },
    //     {
    //       key: '26',
    //       icon: (
    //         <img
    //           src={
    //             current == 26
    //               ? menu_disciplineIntegrationCenter_selected
    //               : menu_disciplineIntegrationCenter
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '学科融合中心',
    //     },
    //     {
    //       key: '27',
    //       icon: (
    //         <img
    //           src={
    //             current == 27
    //               ? menu_featuredSceneTools_selected
    //               : menu_featuredSceneTools
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '特色场景工具',
    //     },
    //   ],
    // },

    // {
    //   key: '3',
    //   icon: (
    //     <img
    //       src={
    //         current.toString().charAt(0) == '3'
    //           ? menu_AIgongchuang_selected
    //           : menu_AIgongchuang
    //       }
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: 'AI共创中心',
    //   children: [
    //     {
    //       key: '31',
    //       icon: (
    //         <img
    //           src={
    //             current == 31
    //               ? menu_mingshigongzuoshi_selected
    //               : menu_mingshigongzuoshi
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '名师工作室',
    //     },
    //     {
    //       key: '32',
    //       icon: (
    //         <img
    //           src={
    //             current == 32
    //               ? menu_jiaoyuzhinengti_selected
    //               : menu_jiaoyuzhinengti
    //           }
    //           width={25}
    //           height={25}
    //         />
    //       ),
    //       label: '教育智能体',
    //     },
    //     // {
    //     //   key: '33',
    //     //   icon: (
    //     //     <img
    //     //       src={
    //     //         current == 33
    //     //           ? menu_jiaoshigongchuang_selected
    //     //           : menu_jiaoshigongchuang
    //     //       }
    //     //       width={25}
    //     //       height={25}
    //     //     />
    //     //   ),
    //     //   label: '教师共创',
    //     // },
    //   ],
    // },
    // {
    //   key: '4',
    //   icon: (
    //     <img
    //       src={current == 4 ? menu_pingce_selected : menu_pingce}
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: 'AI评测中心',
    // },
    // {
    //   key: '5',
    //   icon: (
    //     <img
    //       src={current == 5 ? menu_suyang_selected : menu_suyang}
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: 'AI素养学院',
    // },
  ]
  const [autoOpenCreateApp, setIsAutoOpenCreateApp] = useState(false)
  const [userPoints, setUserPoints] = useState(0)
  const [showSchoolAdminTip, setShowSchoolAdminTip] = useState(false)


  function getUrlParams(url) {
    const urlParams = new URLSearchParams(url.split('?')[1]);
    const params = {};
    for (let param of urlParams.entries()) {
      params[param[0]] = param[1];
    }
    return params;
  }
  function removeAllQueryParams() {
      const url = new URL(window.location);
      url.search = ''; // 清空查询参数
      window.history.pushState({}, '', url.toString()); // 更新浏览器地址栏
  }




  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行

    if(sessionStorage.getItem('currentMenuKey')){
      changeMenuMethod({key:sessionStorage.getItem('currentMenuKey')})
    }
    let params = getUrlParams(window.location.href)
    if(params.outTradeNo){
      setShowPointsInfo(true)
      sessionStorage.setItem('rechargeCurrent',2)
      removeAllQueryParams()
    }
    console.log(Cookies.get('admin_show_tip'))
    console.log('----------------sss-------------')
    console.log(Cookies.get('type'))
    if(Cookies.get('type') == 2&&Cookies.get('admin_show_tip')==1){
      showSchoolTip()
    }

    getUserPoints()
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function showSchoolTip() {
    changeTipStatusRequest((data)=>{
      if(data.ret == 1){
        Cookies.set('admin_show_tip',0)
        setShowSchoolAdminTip(true)
      }
      else if(data.ret == 99){
        messageApi.open({
          type: 'warning',
          // content: data.msg,
          content: data.msg,
        })
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      }
      else{
        messageApi.error(data.msg, 1)
      }
    })
  }
  const getUserPoints = () => {
    getUserPointsRequest((data) => {
      if(data.ret == 1){
        Cookies.set('jifen', data.data.user_jifen)
        Cookies.set('fenpei_jifen', data.data.user_fenpei_jifen)
        Cookies.set('chongzhi_jifen', data.data.user_chongzhi_jifen)
        setUserPoints(data.data.user_jifen)
      }
    })
    // setTimeout((e)=>{
    //     if(timerStatus){
    //         getUserPoints()
    //     }
    // },1000*3)
  }
  const changeMenuMethod = (e) => {
    if(e.key == 'boyaAijk'){
      getAppToken('788', '1', (data) => {
        if (data.ret == '1') {
          window.open('https://aistudio.gamification.org.cn?jwt_trust_token=' + data.data.appToken, '_blank')
        } else {
          message.error(data.msg)
        }
      })
      return
    }
    setShowUserInfoManager(false)
    setGlobalSearchStr('')
    setGlobalSearchType(1)
    dispatch(setCurrentMenuKey(e.key))
    setIsAutoOpenCreateApp(false)
    if (e.key.toString().charAt(0) == 2) {
      changeAIApplicationPage(e.key.toString().charAt(1))
    }
    getUserPoints()
  }

  const globalSearchMethod = (value,type) => {
    if (value == '') {
      message.warning('请输入搜索内容')
    }
    setGlobalSearchStr(value)
    setGlobalSearchType(type)
  }
  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.leftMenus}>
        <img
          className={styles.menuLogo}
          src={require('../../assert/logo_name_icon.png')}
        ></img>
        <div
          className={styles.headerContainer}
          onClick={(e) => {
            if (!showPointsInfo) {
              setShowUserInfoManager(true)
              setGlobalSearchStr('')
              setGlobalSearchType(1)
            }
          }}
        >
          <img
            className={styles.avatar}
            src={
              userHeaderImg == 'null' || userHeaderImg == ''
                ? require('./avatar.png')
                : userHeaderImg
            }
          ></img>
          <div className={styles.rightBox} style={Cookies.get('type') == '3' ? { justifyContent: 'center' } : {}}>
            <Tooltip placement="bottom" title={userName} arrow={mergedArrow}>
              <text className={styles.teacherName}>{userName}</text>
            </Tooltip>
            {Cookies.get('type') != '3' ? (
              <div
                className={styles.gdnInfo}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  getUserPoints()
                  sessionStorage.setItem('rechargeCurrent',0)
                  setShowPointsInfo(true)
                }}
              >
                <text className={styles.gdnTag}>
                  {parseInt(Cookies.get('jifen')) <
                  parseInt(userPoints)
                    ? Cookies.get('jifen')
                    : userPoints}
                </text>
                <text style={{ minWidth: '40px' }}>积分</text>
              </div>
            ) : null}

            <div className={styles.rightTop}>
              <img src={zhuanshiIcon} /> <b style={{ marginLeft: 4 }}>Lv1</b>
            </div>
            {showPointsInfo ? (
              <MyPointsInfo
                openStatus={showPointsInfo}
                onCancel={(e) => {
                  setShowPointsInfo(false)
                }}
              />
            ) : null}
          </div>
        </div>
        {Cookies.get('school_name')!="null" && <div className={styles.schoolBox}>
          <div className={styles.schoolName}>{Cookies.get('school_name')}</div>
        </div>}
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#f5b544',
            },
          }}
        >
          <Menu
            defaultSelectedKeys={
              Cookies.get('type') == 2 ? ['0'] : ['1']
            }
            // defaultOpenKeys={[sessionStorage.getItem('currentMenuKey').substring(0,1)]}
            defaultOpenKeys={[current.toString().substring(0,1)]}
            mode="inline"
            items={
              Cookies.get('type') == 2 ? schoolAdminMenus : items
            }
            onClick={changeMenuMethod}
            selectedKeys={String(
              Math.abs(current) > 60 ? Math.floor(current / 10) : current,
            )}
            inlineCollapsed={false}
          />
        </ConfigProvider>

        {/* <div className={styles.shoppingCartContainer}>
                    <text className={styles.payName}>去支付</text>
                    <img className={styles.shoppingCart} src={require('./shopping_cart.png')}></img>
                </div> */}
      </div>
      <div className={styles.rightMenus}>
        {globalSearchStr != '' ? (
          <GlobalSearchResult
            onCancel={() => {
              changeMenuMethod({
                key: current,
              })
              setGlobalSearchStr('')
              setGlobalSearchType(1)
            }}
            searchStr={globalSearchStr}
            searchType={globalSearchType}
          />
        ) : showUserInfoManager&&Cookies.get('type') == 1 ? (
          <UserInfoManager
            onCancel={() => {
              changeMenuMethod({
                key: current,
              })
              setShowUserInfoManager(false)
            }}
            changeUserAvatar={(value) => {
              Cookies.set('image_url', value)
              setUserHeaderImg(value)
            }}
            changeUserName={(value) => {
              Cookies.set('name', value)
              setUserName(value)
            }}
          />
        ):showUserInfoManager&&Cookies.get('type') == 3 ? (
          <TeacherInfoManager
            onCancel={() => {
              changeMenuMethod({
                key: current,
              })
              setShowUserInfoManager(false)
            }}
            changeUserAvatar={(value) => {
              Cookies.set('image_url', value)
              setUserHeaderImg(value)
            }}
            changeUserName={(value) => {
              Cookies.set('name', value)
              setUserName(value)
            }}
          />
        ) : current == 6 ? (
          <TeacherManager />
        ) : current == 61 ? (
          <UserRechargePoints />
        ) : current == 1 ? (
          <WDBH
            jumpToCreateBot={(e) => {
              dispatch(setCurrentMenuKey('32'))
              setIsAutoOpenCreateApp(true)
            }}
            globalSearch={globalSearchMethod}
          />
        ) : current.toString().charAt(0) == '2' ? (
          <AIApplications
            jumpToCreateBot={(e) => {
              dispatch(setCurrentMenuKey('32'))
              setIsAutoOpenCreateApp(true)
            }}
            globalSearch={globalSearchMethod}
            ref={AIApplicationsRef}
          />
        ) : current == 31 ? (
          <MSGZS
            jumpToCreateBot={(e) => {
              dispatch(setCurrentMenuKey('32'))
              setIsAutoOpenCreateApp(true)
            }}
          />
        ) : current == 32 ? (
          <JYZNT
            autoOpenCreateApp={autoOpenCreateApp}
            globalSearch={globalSearchMethod}
          />
        ) : current == 33 ? (
          <JSGC
            jumpToCreateBot={(e) => {
              dispatch(setCurrentMenuKey('32'))
              setIsAutoOpenCreateApp(true)
            }}
            globalSearch={globalSearchMethod}
          />
        ) : current == 34 ? (
          <ResourceLib
          />
        ) : current == 4 ? (
          <AIPCZX
            jumpToCreateBot={(e) => {
              dispatch(setCurrentMenuKey('32'))
              setIsAutoOpenCreateApp(true)
            }}
            globalSearch={globalSearchMethod}
          />
        ) : current == 5 ? (
          <AISYZX
            jumpToCreateBot={(e) => {
              dispatch(setCurrentMenuKey('32'))
              setIsAutoOpenCreateApp(true)
            }}
          />
        ) : (
          // current == 8?<HomeOld/>:

          <div></div>
        )}
        {showSchoolAdminTip && <ShoolAdminTip closeCommonModal={()=>{
          setShowSchoolAdminTip(false)
        }} openStatus={showSchoolAdminTip} />}
      </div>
    </div>
  )
}

